/**
 * Optional world knowledge the navigation behaviours consult. Left empty until
 * the systems exist (cats / wolves); nothing breaks while they are unset.
 */

import type { Mob } from '../mob';

export const navHooks: {
  /** The mob `self` is afraid of right now (creeper -> cat, skeleton -> wolf), if any. */
  scaredOf?: (self: Mob) => Mob | null;
} = {};
